/* eslint-disable no-undef */
import * as Invite from '../modules/catpainiq';

/**
 * @ngdoc function
 * @name myConsultApp.controller:catpainiqDetailController
 * @description
 * # catpainiqDetailController
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .service('ngCopy', [
    '$window',
    ($window) => {
      const body = angular.element($window.document.body);
      const textarea = angular.element('<textarea/>');
      textarea.css({
        position: 'fixed',
        opacity: '0',
      });

      return (toCopy) => {
        textarea.val(toCopy);
        body.append(textarea);
        textarea[0].select();

        try {
          const successful = document.execCommand('copy');
          if (!successful) throw successful;
          else {
            $('#copy-link-button').text('Copied!');
          }
        } catch (err) {
          /* eslint-disable-next-line no-alert */
          window.prompt('Copy to clipboard: Ctrl+C, Enter', toCopy);
        }

        textarea.remove();
      };
    },
  ])
  .directive('ngClickCopy', [
    'ngCopy',
    (ngCopy) => {
      return {
        restrict: 'A',
        link: (scope, element, attrs) => {
          element.bind('click', () => {
            ngCopy(attrs.ngClickCopy);
          });
        },
      };
    },
  ])
  .directive('fileModel', ['$parse'], ($parse) => {
    return {
      restrict: 'A',
      link: (scope, element, attrs) => {
        const model = $parse(attrs.fileModel);
        const modelSetter = model.assign;

        element.bind('change', () => {
          scope.$apply(() => {
            modelSetter(scope, element[0].files[0]);
          });
        });
      },
    };
  })
  .controller(
    'catpainiqDetail',
    ($scope, $routeParams, $location, $filter, crumble, MediaService, PetsService, utilities) => {
      if ($scope.isAdminUser || $scope.isSuperUser) {
        $location.path('/admin');
      }
      if (!$scope.isTiggerSubscribed && !$scope.isAdminUser) {
        $location.path('/find-a-pet');
      } else {
        $scope.crumble = crumble;
        crumble.update();
      }

      /*
       *  Scope Variables
       *
       */

      $scope.mediaId = $routeParams.mediaId;
      $scope.loadedMedia = [];
      $scope.currentMedia = {};
      $scope.screeningDate = {
        current: null,
        previous: null,
      };
      $scope.isScreeningDateValid = true;
      $scope.weight = 0;
      $scope.media_file_url = null;
      $scope.bodyType = 'Unknown';
      $scope.bodyTypeOptions = {
        'very-thin-waist-ribs-back-and-hip-bones-visible-or': {
          title: 'Underweight',
          img: 'images/feline-bcs-1.png',
        },
        'thin-waist-ribs-back-or-hip-bones-visible-or-easil': {
          title: 'Slightly Underweight',
          img: 'images/feline-bcs-2.png',
        },
        'waist-slimmer-than-chest-ribs-back-and-hip-bones-c': {
          title: 'Ideal',
          img: 'images/feline-bcs-3.png',
        },
        'waist-same-size-as-chest-ribs-back-or-hip-bones-ha': {
          title: 'Slightly Overweight',
          img: 'images/feline-bcs-4.png',
        },
        'waist-larger-than-chest-ribs-back-and-hip-bones-no': {
          title: 'Overweight',
          img: 'images/feline-bcs-5.png',
        },
      };
      $scope.bodyTypeImg = '';
      $scope.screeningErrors = false;

      $scope.inviteEmailSubject = Invite.generateInviteEmailSubject();
      $scope.inviteEmailBody = Invite.generateInviteEmailBody($scope.currentOrganization, false);
      $scope.encodedInviteEmailBody = encodeURIComponent($scope.inviteEmailBody);
      $scope.pageUrl = $location.absUrl();

      /*
       *  Scope Methods
       *
       */

      $scope.updateCurrentMedia = (mediaInfo) => {
        $scope.currentMedia = mediaInfo.files;
        $scope.screeningDate.current = null;

        if ($scope.currentMedia.extra_data) {
          if (!$scope.screeningDate.previous) {
            $scope.screeningDate.current = $scope.currentMedia.extra_data.hasOwnProperty(
              'screening_date',
            )
              ? $scope.currentMedia.extra_data.screening_date
              : null;
          }
          $scope.currentMedia.extra_data.tigger_oa_diagnosis = $scope.currentMedia.extra_data.hasOwnProperty(
            'tigger_oa_diagnosis',
          )
            ? $scope.currentMedia.extra_data.tigger_oa_diagnosis
            : null;

          if (
            $scope.currentMedia.extra_data.rejection_codes &&
            $scope.currentMedia.extra_data.rejection_codes.length > 0
          ) {
            $scope.screeningErrors = true;
          }
        }
      };

      $scope.updateServerMedia = (settings) => {
        MediaService.setMediaInfo($scope.currentMedia.id, settings).then((response) => {
          $scope.updateCurrentMedia(response);
          $scope.loadedMedia = [].concat(response.files);
        });
      };

      $scope.updateMediaFromDM = () => {
        MediaService.updateMediaFromDM($scope.currentMedia.id).then((response) => {
          $scope.updateCurrentMedia(response);
          $scope.loadedMedia = [].concat(response.files);
        });
      };

      $scope.isTiggerVideo = (file) => {
        return file.categories
          ? file.categories.filter((category) => {
              return category.slug === 'tigger-application';
            }).length > 0
          : false;
      };

      $scope.setOADiagnosis = (diagnosis) => {
        let action = null;
        switch (diagnosis) {
          case true:
            action = 'OA Suspected';
            break;
          case false:
            action = 'OA Not Suspected';
            break;
          default:
            action = 'OA Undetermined';
        }

        if (diagnosis !== $scope.currentMedia.extra_data.oa_diagnosis) {
          const settings = {
            files: {
              extra_data: {
                oa_diagnosis: diagnosis,
              },
            },
          };
          $scope.currentMedia.oa_diagnosis = diagnosis;
          $scope.updateServerMedia(settings);
          utilities.submitTelemetry({
            event: 'e_diagnosis',
            eventAction: action,
            orgId: $scope.currentOrganization.id,
            mediaId: $scope.currentMedia.id,
            petId: $scope.currentMedia.pets[0].id,
          });
        }
      };

      $scope.setBCS = (bcs) => {
        if (bcs !== $scope.currentMedia.extra_data.oa_bcs_score) {
          const settings = {
            files: {
              extra_data: {
                oa_bcs_score: bcs,
              },
            },
          };
          $scope.currentMedia.oa_bcs_score = bcs;
          $scope.updateServerMedia(settings);
          utilities.submitTelemetry({
            event: 'e_bcsType',
            eventAction: bcs,
            orgId: $scope.currentOrganization.id,
            mediaId: $scope.currentMedia.id,
            petId: $scope.currentMedia.pets[0].id,
          });
        }
      };

      $scope.setOAScreeningDate = (date) => {
        const settings = {
          files: {
            extra_data: {
              screening_date: date,
            },
          },
        };
        $scope.currentMedia.extra_data.screening_date = date;
        $scope.updateServerMedia(settings);
      };

      $scope.inviteClient = () => {
        utilities.submitTelemetry({
          event: 'e_inviteClient',
          eventAction: 'Invite A Client',
          orgId: $scope.currentOrganization.id,
        });
      };

      $scope.showFAQs = () => {
        utilities.submitTelemetry({
          event: 'e_buttonClick',
          eventAction: 'FAQs',
          orgId: $scope.currentOrganization.id,
        });
      };

      $scope.showSettings = () => {
        utilities.submitTelemetry({
          event: 'e_buttonClick',
          eventAction: 'Settings',
          orgId: $scope.currentOrganization.id,
        });
      };

      $scope.getPMSLink = () => {
        utilities.submitTelemetry({
          event: 'e_getPMSLink',
          eventAction: 'Get Link',
          orgId: $scope.currentOrganization.id,
          mediaId: $scope.currentMedia.id,
        });
      };

      /*
       *  Main
       *
       */
      MediaService.getMediaInfo($scope.mediaId).then((response) => {
        $scope.loadedMedia = [].concat(response.files);
        $scope.updateCurrentMedia(response);

        PetsService.getPetHealthData(
          $scope.currentMedia.pets[0].id,
          'questions',
          'using-the-graphic-below-select-the-cat-shape-that-',
        ).then((res) => {
          if (
            res.questions.length > 0 &&
            res.questions[0].hasOwnProperty('pet_health_data') &&
            res.questions[0].pet_health_data
          ) {
            $scope.bodyType =
              $scope.bodyTypeOptions[res.questions[0].pet_health_data[0].choice.slug].title;
            $scope.bodyTypeImg =
              $scope.bodyTypeOptions[res.questions[0].pet_health_data[0].choice.slug].img;
          }
        });

        PetsService.getPetHealthData($scope.currentMedia.pets[0].id, 'categories', 'weight').then(
          (res) => {
            if (
              res.categories.length > 0 &&
              res.categories[0].hasOwnProperty('pet_health_data') &&
              res.categories[0].pet_health_data
            ) {
              if (res.categories[0].pet_health_data !== null) {
                $scope.weight = res.categories[0].pet_health_data[0].value;
              }
            }
          },
        );
      });

      $scope.$watch('screeningDate.current', (newVal, oldVal) => {
        if (
          $scope.currentMedia.id > 0 &&
          $scope.screeningDate.previous !== $scope.screeningDate.current
        ) {
          const selectedDate = new Date(newVal);
          const previousDate = new Date(oldVal);
          const currentDate = new Date();

          $scope.isScreeningDateValid = selectedDate <= currentDate;

          if (
            $scope.isScreeningDateValid &&
            $filter('date')(selectedDate, 'shortDate') !==
              $filter('date')(previousDate, 'shortDate')
          ) {
            $scope.setOAScreeningDate(newVal);
            if (oldVal !== null) {
              // only fire event if date is changed, not on initial load
              utilities.submitTelemetry({
                event: 'e_screeningDate',
                eventAction: 'Set Screening Date',
                orgId: $scope.currentOrganization.id,
                mediaId: $scope.currentMedia.id,
                petId: $scope.currentMedia.pets[0].id,
              });
            }
          }
        }
      });
    },
  );
